export const deleteDialogText = {
    title: 'chatPage.SpeechBubble.confirmDeletion.title',
    content: 'chatPage.SpeechBubble.confirmDeletion.content',
    confirm: 'common.confirm',
    cancel: 'common.cancel',
}

export const tooltipIconsText = {
    edit:  'chatPage.SpeechBubble.edit.tooltip',
    delete:  'chatPage.SpeechBubble.delete.tooltip',
}
